<mat-card>
    <ng-container *ngIf="workflowElementArray && workflowElementArray.length > 0; else noData">
        <div class="feature-workflow-expand-title">Timeline view</div>
        <div class="timeline-view-box" *ngFor="let workflow of workflowElementArray"><app-tm-view-wf-row
                [workflow]="workflow"></app-tm-view-wf-row></div>
    </ng-container>
    <ng-template #noData>
        <div class="noDataMsg">{{getNoData}}</div>
    </ng-template>
</mat-card>